import { createSelector } from '@reduxjs/toolkit';
import type { ProductsListState } from 'reactApp/modules/productsList/productsList.types';
import type { RootState } from 'reactApp/store';

const getProductsState = (state: RootState): ProductsListState => state.productsList;

const getNormalizedProducts = createSelector(getProductsState, (productsState) => productsState.normalizedList);

const getLoadingState = createSelector(getProductsState, ({ isLoading, isLoaded, hasError }) => ({ isLoading, isLoaded, hasError }));

const getProductById = createSelector(
    getNormalizedProducts,
    (_, id) => id,
    (products, id) => products[id]
);

export const ProductsListSelectors = {
    getLoadingState,
    getProductById,
};
